import React, { useCallback, useEffect } from 'react';
import { Title, useDataProvider } from 'react-admin';
import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import DataCard from "./Cards";
import StorageIcon from "@mui/icons-material/Storage";
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import BoltIcon from '@mui/icons-material/Bolt';
import TvIcon from '@mui/icons-material/Tv';
import Graphs from "./Charts";
import Servers from "./TopServers";


const Dashboard = () => {

    const [total_servers, setTotalServers] = React.useState<any>('');
    const [total_connections, setTotalConnections] = React.useState<any>('');
    const [total_outrate, setTotalOutrate] = React.useState<any>('');
    const [total_rating, setTotalRating] = React.useState<any>('');
    const [graph_data, setGraphData] = React.useState<any>({});

    // Graph general data
    let connections = [];
    let outrate = [];
    let server_address = [];

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                padding: 20,
                paddingRight: 28,
                paddingLeft: 28
            },
            large: {
                marginTop: 10,
                marginLeft: 10,
                marginBottom: 10,
                width: theme.spacing(10),
                height: theme.spacing(10),
            }
        })
    );

    const classes = useStyles();
    const dataProvider = useDataProvider();

    const fetchAnalyticsData = useCallback(async () => {

        await dataProvider.getOne(
            'analytics/all',
            {
                id: "",
            }, {
            onSuccess: async (response) => {
                setTotalServers(response.data.total);

            }
        });

        await dataProvider.getOne(
            'analytics/connections',
            {
                id: "",
            }, {
            onSuccess: async (response) => {
                console.log(response)
                setTotalConnections(response.data.Connections);

            }
        });

        await dataProvider.getOne(
            'analytics/outrate',
            {
                id: "",
            }, {
            onSuccess: async (response) => {
                setTotalOutrate(Math.round(response.data.Outrate / 1000000));
            }
        });

        await dataProvider.getOne(
            'analytics/rating',
            {
                id: "",
            }, {
            onSuccess: async (response) => {
                setTotalRating(Math.round(response.data.Rating));
            }
        });

        await dataProvider.getList(
            'servers',
            {
                pagination: { page: 1, perPage: 5 },
                sort: { field: 'title', order: 'ASC' },
                filter: {}
            }, {
            onSuccess: async (response) => {
                const result = response.data;

                result.forEach(data => {
                    // @ts-ignore
                    connections.push(data.connections_live);
                    // @ts-ignore
                    outrate.push(Math.round(data.outrate_live / 1000000));
                    // @ts-ignore
                    server_address.push(data.server_address);
                });

                const data = {
                    labels: server_address,
                    datasets: [
                        {
                            label: 'Connections',
                            data: connections,
                            backgroundColor: 'rgb(255, 99, 132)',
                        },
                        {
                            label: 'Outrate',
                            data: outrate,
                            backgroundColor: 'rgb(54, 162, 235)',
                        },
                    ],
                }

                console.log(data)
                setGraphData(data);
            }
        });

    }, []);

    const API_KEY = process.env.REACT_APP_USERNAME

    useEffect(() => {
        if (localStorage.getItem("access_token")) {
            fetchAnalyticsData();
        }
    }, [localStorage.getItem("access_token")]);

    return (
        <div className={classes.root}>
            <Title title="Dashboard" />
            <Grid container spacing={2} style={
                {
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex", //changed value of alignItems
                }
            }>
                <Grid item md={3}>
                    <DataCard icon={StorageIcon} title="Servers" subtitle={total_servers}
                    />
                </Grid>
                <Grid item md={3}>
                    <DataCard icon={TvIcon} title="Live Connections" subtitle={total_connections}
                    />
                </Grid>
                <Grid item md={3}>
                    <DataCard icon={NetworkCheckIcon} title="Current Bandwidth" subtitle={total_outrate + "Mbps"}
                    />
                </Grid>
                <Grid item md={3}>
                    <DataCard icon={BoltIcon} title="CDN Utilization" subtitle={total_rating + "%"}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item md={5} style={{ paddingTop: 20 }}>
                    <Servers />
                </Grid>
                <Grid item md={7} style={{ paddingTop: 40 }}>
                    <Graphs data={graph_data} />
                </Grid>
            </Grid>
        </div>
    )
}

export default Dashboard;